//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import {PublicAppLayout} from 'app_components/layouts/public'
import AllThingsModule from 'app_components/modules/academic/allthings'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../articulosScreen.scss'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'

// @ADD Component types
interface IArticulosScreenLayoutProps {}

const ArticulosScreenLayout: React.FC<IArticulosScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <PublicAppLayout>
      <div className="articulos-screen--layout">
        <TextComponent type='title' as='h2' textTransform='none'>Artículos</TextComponent>
        <AllThingsModule type={'research'}/>
      </div>
    </PublicAppLayout>
  )
}

export default ArticulosScreenLayout
